<h2 mat-dialog-title>{{ isEditMode ? 'Edit User' : 'Add New User' }}</h2>
<mat-dialog-content>
    <form [formGroup]="userForm" class="user-form">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Username</mat-label>
            <input matInput formControlName="username" placeholder="Enter username">
            <mat-error *ngIf="userForm.get('username')?.hasError('required')">Username is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" placeholder="Enter email" type="email">
            <mat-error *ngIf="userForm.get('email')?.hasError('required')">Email is required</mat-error>
            <mat-error *ngIf="userForm.get('email')?.hasError('email')">Enter a valid email</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" placeholder="Enter name">
            <mat-error *ngIf="userForm.get('name')?.hasError('required')">Name is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Organization</mat-label>
            <input matInput formControlName="organization" placeholder="Enter organization">
            <mat-error *ngIf="userForm.get('organization')?.hasError('required')">Organization is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Group</mat-label>
            <input matInput formControlName="group" placeholder="Enter group">
            <mat-error *ngIf="userForm.get('group')?.hasError('required')">Group is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Access Level</mat-label>
            <mat-select formControlName="access">
                <mat-option *ngFor="let opt of accessOptions" [value]="opt">{{ opt }}</mat-option>
            </mat-select>
            <mat-error *ngIf="userForm.get('access')?.hasError('required')">Access level is required</mat-error>
        </mat-form-field>
    </form>
    <div *ngIf="errorMessage" class="alert alert-danger mt-2" role="alert">{{ errorMessage }}</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="submitting">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="userForm.invalid || submitting">
        {{ submitting ? 'Saving...' : (isEditMode ? 'Update' : 'Create') }}
    </button>
</mat-dialog-actions>
